module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0712":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./src/window-size.js



var window_size_WindowSize =
/*#__PURE__*/
function () {
  function WindowSize() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$defaults = _ref.defaults,
        defaults = _ref$defaults === void 0 ? {
      width: 800,
      height: 600
    } : _ref$defaults,
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? 50 : _ref$delay;

    _classCallCheck(this, WindowSize);

    this._width = defaults.width;
    this._height = defaults.height;
    this._delay = delay;
    this._timer = null;
    this._initialized = false;
    this._handler = this._handleResize.bind(this);
  }

  _createClass(WindowSize, [{
    key: "_handleResize",
    value: function _handleResize() {
      var _this = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this.update();
      }, this._delay);
    }
  }, {
    key: "update",
    value: function update() {
      this._width = window.innerWidth;
      this._height = window.innerHeight;
    }
  }, {
    key: "setDelay",
    value: function setDelay(delay) {
      this._delay = delay;
    }
  }, {
    key: "init",
    value: function init() {
      if (typeof window === 'undefined') {
        return this;
      }

      if (this.initialized) {
        return this;
      }

      this.update();
      window.addEventListener('resize', this._handler);
      this._initialized = true;
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.initialized) {
        return this;
      }

      window.removeEventListener('resize', this._handler);
      this._initialized = false;
      return this;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "initialized",
    get: function get() {
      return this._initialized;
    }
  }]);

  return WindowSize;
}();


// CONCATENATED MODULE: ./src/mixin.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return windowSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixin; });


var windowSize = new window_size_WindowSize().init();
var vm = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
  data: {
    windowSize: windowSize
  }
});
var mixin = {
  computed: {
    windowWidth: function windowWidth() {
      return vm.windowSize.width;
    },
    windowHeight: function windowHeight() {
      return vm.windowSize.height;
    }
  }
};

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "b635":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vueWindowSizeMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return vueWindowSize; });
/* harmony import */ var _mixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0712");
 // mixin

var vueWindowSizeMixin = _mixin__WEBPACK_IMPORTED_MODULE_0__[/* mixin */ "a"]; // Public API

var vueWindowSize = {
  setDelay: function setDelay(delay) {
    _mixin__WEBPACK_IMPORTED_MODULE_0__[/* windowSize */ "b"].setDelay(delay);
  },
  init: function init() {
    _mixin__WEBPACK_IMPORTED_MODULE_0__[/* windowSize */ "b"].init();
  },
  destroy: function destroy() {
    _mixin__WEBPACK_IMPORTED_MODULE_0__[/* windowSize */ "b"].destroy();
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 50 : _ref$delay;

  if (install.installed) return;
  install.installed = true;
  _mixin__WEBPACK_IMPORTED_MODULE_0__[/* windowSize */ "b"].setDelay(delay);
  Vue.mixin({
    mixins: [_mixin__WEBPACK_IMPORTED_MODULE_0__[/* mixin */ "a"]]
  });
}

var plugin = {
  install: install
};
var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/index.js
var src = __webpack_require__("b635");

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport vueWindowSizeMixin */__webpack_require__.d(__webpack_exports__, "vueWindowSizeMixin", function() { return src["c" /* vueWindowSizeMixin */]; });
/* concated harmony reexport vueWindowSize */__webpack_require__.d(__webpack_exports__, "vueWindowSize", function() { return src["b" /* vueWindowSize */]; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src["a" /* default */]);



/***/ })

/******/ });
//# sourceMappingURL=vue-window-size.common.js.map